import React from 'react';
import PropTypes from 'prop-types';
import { Tab } from 'semantic-ui-react';
import AcademicExpressionForm from '../forms/AcademicExpressionForm';
import CorpusSearchForm from '../forms/CorpusSearchForm';
import BundlesForm from '../forms/BundlesForm';
import '../../style.css';

const panes = [
  {
    menuItem: 'Expresión académica',
    pane: (
      <Tab.Pane key={1}>
        <AcademicExpressionForm />
      </Tab.Pane>
    )
  },
  {
    menuItem: 'Funciones discursivas',
    pane: (
      <Tab.Pane key={3}>
        <BundlesForm />
      </Tab.Pane>
    )
  },
  {
    menuItem: 'Búsqueda en Corpus',
    pane: (
      <Tab.Pane key={2}>
        <CorpusSearchForm/>
      </Tab.Pane>
    )
  }
];

class Search extends React.Component {
  handleChange = () => {
    this.props.history.push('/search');
  };

  render() {
    if(this.props.match.path === '/discursiva/:discursiva'){
      return (
        <Tab
          panes={panes}
          onTabChange={this.handleChange}
          renderActiveOnly={false}
          defaultActiveIndex={1}
        />
      );
    } else {
      return (
        <Tab
          panes={panes}
          onTabChange={this.handleChange}
          renderActiveOnly={false}
        />
      );
    }   
  }
}


Search.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default Search;
